module.exports = __webpack_public_path__ + "static/media/contact.e42875a9.svg";